function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

// Create our number formatter.
const moneyFormatter = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
});

class PriceCalculator extends HTMLElement {
  constructor() {
    super();

    this.quantity = 1;

    this.productForm = document.querySelector("#" + this.dataset.productFormId);

    this.productForm.addEventListener('change', this.onVariantChange.bind(this));


    this.quantityInputEls = this.querySelectorAll(".calc_qt-sync");

    this.submitButtonEls = this.querySelectorAll('.calc__submit-button');
      
    this.querySelectorAll('.calc_qt-minus').forEach(el => el.addEventListener('click', this.decreaseQuantity.bind(this)));
    this.querySelectorAll('.calc_qt-plus').forEach(el => el.addEventListener('click', this.increaseQuantity.bind(this)));

    this.quantityInputEls.forEach(el => el.addEventListener('click', this.onQuantityChange.bind(this)));
  }

  onVariantChange() {
    this.updateCurrentVariant();
    this.renderResults();
  }
  
  increaseQuantity() {
    const quantity = this.quantity + 1;
    this.updateQuantity(quantity);
  }
  
  decreaseQuantity() {
    if (this.quantity > 1) {
      const quantity = this.quantity - 1;
      this.updateQuantity(quantity);
    }
  }
  
  onQuantityChange(e) {
    const quantity = parseInt(e.target.value);
    this.updateQuantity(quantity);
  }

  updateQuantity(quantity) {
    this.quantity = quantity;
    this.quantityInputEls.forEach(el => el.value = quantity);
    this.leasingFormQuantityInputEl.value = this.quantity;
  }

  updateCurrentVariant() {
    this.currentVariantId = this.productForm.querySelector('input[name="id"]').value;
    this.variants = this.variants || JSON.parse(this.querySelector('#variants').textContent);
    this.currentVariant = this.variants.find(variant => variant.id == this.currentVariantId);
  }

  renderResults() {
    this.leasingFormIdInputEl.value = this.leasingVariant.id;
    this.cashFormIdInputEl.value = this.currentVariantId;
    this.leasingFormVariantIdInputEl.value = this.currentVariant.id;
    const variantFinitionsEl = this.querySelector(`#variants-${this.currentVariantId}-options`);
    if (variantFinitionsEl) {
      this.leasingFormMailFinitionsInputEl.value = variantFinitionsEl.textContent.trim();
    }
    const variantImageEl = this.querySelector(`#variants-${this.currentVariantId}-image`);
    if (variantImageEl) {
      this.leasingFormMailImageInputEl.value = variantImageEl.textContent.trim();
    }
  }

}

customElements.define('price-calculator', PriceCalculator);